import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Divider, Link, useTheme } from '@mui/material';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import _ from 'lodash';
import React, { useContext } from 'react';
import Date from '../common/date.span';
import { useMenu } from '../common/dialog.util';
import StatusChip from '../common/status.chip';
import { lighter } from '../common/util';
import { DialogsContext } from '../contexts';
import StudentAvatar from '../student/student.avatar';
import SubjectAvatar from '../subject/subject.avatar';
import ActivityScoreInput from './activity.score.input';
import { useAuth } from '../auth/auth.provider';

export default function ActivityCard(props) {
	let { activity, date } = props;
	const theme = useTheme();
	const menu = useMenu();
	const { dialogs } = useContext(DialogsContext);
	const { can } = useAuth();

	if (!activity?.id) {
		return;
	}

	const courseDetail = activity?.courseDetail;
	const course = courseDetail?.course;
	const subject = course?.subject;
	const enrollment = activity?.enrollment;
	const student = enrollment?.student;

	if( !courseDetail || !course || !enrollment ){
		return;
	}

	const breadcrumbs = [];
	let parentDetail = courseDetail?.parentDetail;
	while (parentDetail) {
		breadcrumbs.push(parentDetail?.name);
		parentDetail = parentDetail?.parentDetail;
	}

	let name = courseDetail?.name;
	if (!_.isNaN(Number(name)) && courseDetail?.parentDetail?.name) {
		name = courseDetail?.parentDetail?.name + "." + name;
	}

	const dense = props.variant == 'dense';
	const mainText = dense ? 'subtitle2' : 'h6';

	const optionsMenu = (
		<Box>
			<IconButton className="hover-muted" onClick={(e) => menu.open(e)} sx={{ mx: -2 }}>
				<MoreVertIcon />
			</IconButton>
			<Menu open={menu.isOpen} onClose={() => menu.close()} anchorEl={menu.anchor}>
				{/* <MenuItem onClick={() => { menu.close(); dialogs.open('activity', activity) }}>Edit</MenuItem> */}
				<MenuItem onClick={() => { menu.close(); dialogs.open('activityReschedule', [activity]) }}>Reschedule...</MenuItem>
				<MenuItem onClick={() => { menu.close(); dialogs.open('activityUnschedule', [activity]) }}>Unschedule...</MenuItem>
				{/* <MenuItem onClick={() => { menu.close(); dialogs.open('activityUnenroll', activity) }}>Uneroll...</MenuItem> */}
				{/* <Divider /> */}
				{/* <MenuItem onClick={() => { menu.close(); onDelete(activity.id) }}>Delete</MenuItem> */}
			</Menu>
		</Box>
	);

	const href = '/courses/' + course?.id + '/enrollments/' + enrollment?.id;
	const nowrapSx = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: "ellipsis", '&:hover .MuiTypography-h6':{textDecoration:'underline'} };
	const cardContent = (
		<CardContent sx={{ p: 0, display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
			<Stack sx={{ p: dense ? 1 : 2 }} spacing={dense ? 1 : 2} alignItems="center">
				{can('activity.edit') && (
					<Box className="hover-subtle">
						<StatusChip status={activity?.status} activity={activity} date={date} type="icon" size={dense ? 24 : 32} />
					</Box>
				)}
				<Divider orientation="vertical" />
				<Link underline="none" href={href} sx={nowrapSx}>
					<Stack direction="column" spacing={0.5}>
						{props.hideCourse != true &&
							<Stack alignItems="center" spacing={1}>
								<SubjectAvatar subject={subject} size={16} />
								<Typography variant="h6" sx={nowrapSx} title={course?.name}>{course?.name}</Typography>
							</Stack>
						}
						<Stack alignItems="center" spacing={1} sx={{ pb: 0.75 }} title={breadcrumbs.join(' > ')}>
							{breadcrumbs.map(breadcrumb =>
								<React.Fragment key={breadcrumb}>
									<Typography variant={mainText} sx={{ color: theme.palette.action.active }} title={course?.name}>{breadcrumb}</Typography>
									<ChevronRightIcon sx={{ fontSize: 16, color: theme.palette.action.active }} />
								</React.Fragment>
							)}
							<Typography variant={mainText} title={name} sx={nowrapSx}>{name}</Typography>
						</Stack>
						{dense != true && <Date variant="subtitle2" date={activity?.startDate} format="MMMM D" />}
					</Stack>
				</Link>
				<Box sx={{ flex: 1 }}></Box>

				{can('activity.edit') && props.hideScore != true && <ActivityScoreInput activity={activity} />}
				{props.hideStudent != true && <StudentAvatar student={student} size={24} />}

				{can('activity.edit') && optionsMenu}
			</Stack>
		</CardContent>
	);

	const colour = course?.colour || subject?.colour || theme.palette.info.main;
	const cardSx = { width: '100%', background: lighter(colour, 0.8, theme) };
	return (
		<Card sx={cardSx} className="hover-toggle">
			{cardContent}
		</Card>
	)
}